import { useEffect } from "react";
import queryString from "query-string";

import FeedbackBanner from "shared/util/FeedbackBanner";
import _str from "shared/util/_str";

const PAYPAL_ERROR_TYPE = {
	hasPlan: "has_plan",
};

/**
 * Show FeedbackBanner for PayPal errors returned to us via query params.
 * @param {object} location - current browser location.
 */
function usePayPalErrorHandler(location) {
	const {
		cf,
		paypalerror,
		error,
	} = queryString.parse(location.search);

	useEffect(() => {
		// Early exit if neither of these are present.
		if (cf !== "paypal_failure" && !paypalerror) {
			return;
		}

		const message = error === PAYPAL_ERROR_TYPE.hasPlan
			? _str("We couldn’t make that purchase because you’re already on a plan!")
			: _str("Your purchase didn’t go through. Please try again!");

		FeedbackBanner.open({
			message,
			type: "error",
			timeout: 10 * 1000,
		});
	}, [cf, error, paypalerror]);
}

export default usePayPalErrorHandler;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/usePayPalErrorHandler.js